/* eslint-disable complexity */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FilterableSelect, Option } from 'carbon-react/lib/components/select';
import classNames from 'classnames';
import Tooltip from 'carbon-react/lib/components/tooltip';

import { ChartOfAccountsAccount } from '@futrli-sdk/predict';

import * as styles from './basic-info.scss';
import { TOTALS_CODE } from '../../types';

interface Props {
  entityNotSelected?: boolean;
  accountIndex: string;
  predictionContentTouched: boolean;
  accountRows?: ChartOfAccountsAccount[];
  handleAccountChangeCarbon: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AccountAutocomplete = ({
  accountRows = [],
  entityNotSelected,
  accountIndex,
  predictionContentTouched,
  handleAccountChangeCarbon
}: Props) => {
  const intl = useIntl();
  if (entityNotSelected) {
    return (
      <Tooltip
        message={
          <FormattedMessage id="predict.choose_sub_entity_first" defaultMessage="Please choose a sub-entity first" />
        }
      >
        <div style={{ width: 320, marginRight: 8 }}>
          <FilterableSelect
            size="large"
            key="account"
            id="account-selector"
            label={intl.formatMessage({
              id: 'common.account',
              defaultMessage: 'Account'
            })}
            placeholder={
              !entityNotSelected
                ? intl.formatMessage({
                    id: 'predict.start_typing_find_account',
                    defaultMessage: 'Start typing to find your account'
                  })
                : undefined
            }
            value={accountIndex || ''}
            onChange={handleAccountChangeCarbon}
            mb={0}
            disabled={entityNotSelected}
            error={!entityNotSelected && predictionContentTouched && !accountIndex.length}
          >
            {accountRows.map((o: ChartOfAccountsAccount, i: number) => (
              <Option
                key={`${o.code}-${i}`}
                value={o.code}
                text={o.name}
                disabled={o.code === TOTALS_CODE}
                className={classNames({
                  [styles.categoryItemCarbon]: o.code === TOTALS_CODE,
                  [styles.accountItemCarbon]: o.code !== TOTALS_CODE
                })}
              >
                <div style={{ width: 6 }}></div>
                <div>{o.name}</div>
              </Option>
            ))}
          </FilterableSelect>
        </div>
      </Tooltip>
    );
  }

  return (
    <div style={{ width: 320, marginRight: 8 }}>
      <FilterableSelect
        size="large"
        key="account"
        id="account-selector"
        label={intl.formatMessage({
          id: 'common.account',
          defaultMessage: 'Account'
        })}
        placeholder={
          !entityNotSelected
            ? intl.formatMessage({
                id: 'predict.start_typing_find_account',
                defaultMessage: 'Start typing to find your account'
              })
            : undefined
        }
        value={accountIndex || ''}
        onChange={handleAccountChangeCarbon}
        mb={0}
        disabled={entityNotSelected}
        error={!entityNotSelected && predictionContentTouched && !accountIndex.length}
      >
        {accountRows.map((o: ChartOfAccountsAccount, i: number) => (
          <Option
            key={`${o.code}-${i}`}
            value={o.code}
            text={o.name}
            disabled={o.code === TOTALS_CODE}
            className={classNames({
              [styles.categoryItemCarbon]: o.code === TOTALS_CODE,
              [styles.accountItemCarbon]: o.code !== TOTALS_CODE
            })}
          >
            <div style={{ width: 6 }}></div>
            <div>{o.name}</div>
          </Option>
        ))}
      </FilterableSelect>
    </div>
  );
};
